import { useState } from 'react';

import { Button, Variant } from '@indicia/component-library';

import RenderMode from '../../../../shared/models/survey/RenderMode';
import SurveyAnswer from '../../../../shared/models/survey/SurveyAnswer';
import SurveyChoiceOption from '../../../../shared/models/survey/SurveyChoiceOption';
import { SurveyMultipleChoiceQuestionType } from '../SurveyQuestionTypes';

import '../SurveyQuestion.scss';

type PropType = SurveyMultipleChoiceQuestionType & {
  id: string;
  onAnswerSelect: (answer: SurveyAnswer) => void;
  options: SurveyChoiceOption[];
  bem: (element: string | null, modifier: string | null, condition: boolean) => string;
  previousAnswer: string[];
  renderMode: RenderMode;
};

const SurveyMultipleChoiceQuestion = ({ bem, id, options, onAnswerSelect, previousAnswer, renderMode }: PropType) => {
  const [selectedAnswers, setSelectedAnswers] = useState<string[]>(previousAnswer || []);
  const handleClick = (optionId: string) => {
    const index = selectedAnswers.indexOf(optionId);
    let answers: string[] = [];
    if (index !== -1) {
      answers = [];
    } else {
      answers = [optionId];
    }

    setSelectedAnswers(answers);
    onAnswerSelect({
      value: answers,
      questionId: id,
    });
  };

  return (
    <div
      className={`${bem('multiple-choice', null, true)} ${bem(
        'multiple-choice',
        'vertical',
        renderMode === RenderMode.Vertical
      )}`}
    >
      {options.map(({ description, id: optionId }) => (
        <Button
          key={optionId}
          variant={selectedAnswers.includes(optionId) ? Variant.Solid : Variant.Outlined}
          onClick={() => handleClick(optionId)}
        >
          {description}
        </Button>
      ))}
    </div>
  );
};

export default SurveyMultipleChoiceQuestion;
